import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";

export const useGetAssignedDistributors = (dealerCompanyID: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['assigned-distributors', dealerCompanyID],
        queryFn: async () => await apiClient.get('company/assigned-distributors') as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
